// extracted by mini-css-extract-plugin
export default {"container":"JoinTeam_container__z0KOe","centered":"JoinTeam_centered__SaEV-"};